import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/avexo.png'


const _hoisted_1 = {
  id: "navbar",
  class: "fixed top-0 z-40 flex w-full flex-row items-center bg-parrot px-2 sm:px-4 justify-between border-b border-gray-200"
}
const _hoisted_2 = { class: "sticky justify-center top-0 z-40 flex h-14 sm:h-16 shrink-0 items-center gap-x-2 sm:gap-x-4 bg-parrot px-2 sm:px-4 md:px-6 lg:px-8 shadow-sm" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Abrir menu", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  class: "hidden lg:block",
  href: "/"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-auto h-10",
    alt: "Avexo logo",
    src: _imports_0
  })
], -1)
const _hoisted_5 = { class: "flex-row items-center py-1 text-base sm:text-lg text-white sm:flex" }
const _hoisted_6 = { class: "flex flex-1 gap-x-4 self-stretch lg:gap-x-6" }
const _hoisted_7 = { class: "flex items-center gap-x-4 lg:gap-x-6" }


import { Bars3Icon } from "@heroicons/vue/24/outline";
import TenantSelector from "./tenant-selector.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'app-navbar',
  emits: ["toggleSidebar"],
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "-m-2.5 p-2.5 text-parrot-1 lg:hidden",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggleSidebar')))
      }, [
        _hoisted_3,
        _createVNode(_unref(Bars3Icon), {
          class: "h-6 w-6",
          "aria-hidden": "true"
        })
      ]),
      _hoisted_4
    ]),
    _createElementVNode("ul", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TenantSelector)
        ])
      ])
    ])
  ]))
}
}

})